import React, { useState } from "react";
import "./styles.css";
import "@mkhuda/react-shaka-player/dist/ui.css";
import { ReactShakaPlayer } from "@mkhuda/react-shaka-player";
import ReactJson from "react-json-view";

export default function App() {
  const sampleUrl =
    "https://reuters-reutersnow-1.plex.wurl.com/manifest/playlist.m3u8";
  const [videoUrl, setVideoUrl] = useState("");
  const [playerStatus, setPlayerStatus] = useState("");
  const [stats, catchStats] = useState({});

  const handleOnChange = (event) => {
    const value = event.target.value;
    setVideoUrl(value);
  };

  const params = new URLSearchParams(window.location.search);
  const hasParam = params.has("source");
  const paramsSourceVideo = params.get("source");

  return (
    <div className="App">
      <div className="App-main">
        <input
          className="Input"
          placeholder="Input URL here"
          value={videoUrl}
          onChange={handleOnChange}
        />
        {videoUrl !== "" ? (
          <ReactShakaPlayer
            autoPlay={true}
            superConfig="STREAMING"
            src={hasParam ? paramsSourceVideo : videoUrl}
            onPlay={() => setPlayerStatus("playing")}
            onPause={() => setPlayerStatus("paused")}
            onEnded={() => setPlayerStatus("ended")}
            onBuffering={(status) => {
              if (status === true) {
                setPlayerStatus("buffering");
              }
            }}
            onPlayerError={(error) => {
              console.log(error);
              setPlayerStatus("error");
            }}
            onStatsChanged={(stats) => catchStats(stats)}
          />
        ) : (
          <p>"Input your video"</p>
        )}
        <div className="player-status-container">
          <div className="left">Player Status</div>
          <div className="right">{playerStatus}</div>
        </div>
        <div className="player-config">
          {/* <ReactJson name="playerConfigurations" src={configs} /> */}
          <ReactJson name="mediaStats" src={stats} />
        </div>
        <p>
          <a
            href="https://www.npmjs.com/package/@mkhuda/react-shaka-player"
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="npm module: @mkhuda/react-shaka-player"
              src="https://img.shields.io/badge/NPM-%40mkhuda%2Freact--shaka--player-red?style=for-the-badge&logo=npm"
            />
          </a>
          <a
            href="https://github.com/mkhuda/react-shaka-player"
            target="_blank"
            rel="noreferrer"
          >
            <img
              alt="github: @mkhuda/react-shaka-player"
              src="https://img.shields.io/badge/Github-%40mkhuda%2Freact--shaka--player-blue?style=for-the-badge&logo=github"
            />
          </a>
        </p>
      </div>
    </div>
  );
}
